import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiZap, FiGift, FiStar } = FiIcons;

// Fallback promos if Airtable is not set up yet
const FALLBACK_PROMOS = [
  { text: '⚡ Free Site Visit for CCTV & Solar Installations this month!', color: 'from-blue-600 to-cyan-500' },
  { text: '🎁 Weekly Lucky Draw — Win Earphones, Cables & Free Services! Enter Now →', color: 'from-purple-600 to-pink-500' },
  { text: '🏪 Visit our Electronics Store — Earphones, Data Cables, AUX Cables & more!', color: 'from-orange-500 to-yellow-500' },
  { text: '🚨 24/7 Emergency Electrical Service — Call +91 99066 69918', color: 'from-red-600 to-orange-500' },
];

const COLORS = [
  'from-blue-600 to-cyan-500',
  'from-purple-600 to-pink-500',
  'from-orange-500 to-yellow-500',
  'from-red-600 to-orange-500',
  'from-green-600 to-teal-500',
  'from-indigo-600 to-purple-500',
];

const PromoBar = ({ onHeightChange }) => {
  const [visible, setVisible] = useState(true);
  const [current, setCurrent] = useState(0);
  const [promos, setPromos] = useState(FALLBACK_PROMOS);

  // Fetch promos from Airtable
  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const res = await fetch('/api/admin-airtable?path=Promos%3Fsort%5B0%5D%5Bfield%5D%3DOrder%26sort%5B0%5D%5Bdirection%5D%3Dasc');
        if (!res.ok) return; // silently use fallback
        const data = await res.json().catch(() => ({}));
        const active = data.records
          .filter(r => r.fields.Active && r.fields.Message)
          .map((r, i) => ({
            text: `${r.fields.Emoji || ''} ${r.fields.Message}`.trim(),
            color: COLORS[i % COLORS.length],
          }));
        if (active.length > 0) setPromos(active);
      } catch {
        // silently use fallback promos
      }
    };
    fetchPromos();
  }, []);

  // Rotate promos
  useEffect(() => {
    if (promos.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % promos.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [promos]);

  useEffect(() => {
    if (onHeightChange) onHeightChange(visible ? 36 : 0);
  }, [visible]);

  if (!visible) return null;

  const promo = promos[current] || FALLBACK_PROMOS[0];

  return (
    <div className={`fixed top-0 left-0 right-0 z-[60] h-9 bg-gradient-to-r ${promo.color} flex items-center justify-between px-4 transition-all duration-500`}>
      <div className="flex-1 overflow-hidden flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.p
            key={current}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.4 }}
            className="text-white text-xs sm:text-sm font-medium text-center truncate px-8"
          >
            {promo.text}
          </motion.p>
        </AnimatePresence>
      </div>
      <button
        onClick={() => setVisible(false)}
        className="text-white/70 hover:text-white transition-colors flex-shrink-0 ml-2"
      >
        <SafeIcon icon={FiX} className="text-sm" />
      </button>
    </div>
  );
};

export default PromoBar;
